import React from 'react';
import { Clickable } from '@moda/om';
import { SetupApplePaySession } from './SetupApplePaySession';
import { useIsApplePaySupported } from './useIsApplePaySupported';
import './ApplePayButton.scss';

const APPLE_PAY_BUTTON_ID = 'apple-pay-button';

type Props = {
  size?: 'small' | 'large';
  onClick?: () => void;
  session?: ApplePaySession | null;
};

export const ApplePayButton: React.FC<Props> = ({ size = 'large', onClick, session }) => {
  const isApplePaySupported = useIsApplePaySupported();

  return isApplePaySupported ? (
    <Clickable className={`ApplePayButton ApplePayButton--${size}`} onClick={onClick}>
      {session && <SetupApplePaySession session={session} />}
      <div id={APPLE_PAY_BUTTON_ID} />
    </Clickable>
  ) : null;
};
